export default function FilterFaq() {

    if ($('.v-faq__filter').length > 0) {

        const $filter = {
            btn: $('.v-faq__filter button'),
            item: $('.c-collapse__item'),
            data: 'collapse-filter'
        }

        $filter.btn.click(function () {
            const $value = $(this).data($filter.data);

            $filter.btn.each(function () {
                if ($(this).hasClass('js-isActive')) {
                    $(this).removeClass('js-isActive');
                }
            })

            if (!$(this).hasClass('js-isActive')) {
                $(this).addClass('js-isActive');
            }

            if ($value === '*') {
                $filter.item.each(function () {
                    $(this).slideDown(400);
                });
            } else {
                $filter.item.each(function () {
                    if (!$(this).hasClass($value)) {
                        $(this).slideUp(400);
                    } else {
                        $(this).slideDown(400);
                    }
                });
            }
        });
    }
}
